<div class="row">
    <div class="col">

        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" cdk-table [dataSource]="usersWithDone" [trackBy]="trackByCardid">

                <ng-container cdkColumnDef="navn">
                  <th cdk-header-cell *cdkHeaderCellDef>Navn</th>
                  <td cdk-cell *cdkCellDef="let user">
                    <span>{{user.fornavn}} {{user.efternavn}}</span>
                  </td>
                </ng-container>

                <ng-container *ngFor="let day of [1,2,3,4,5,6,7]">
                    <ng-container [cdkColumnDef]="'doneDag'+day">
                        <th cdk-header-cell *cdkHeaderCellDef>
                            <div class="text-center">
                                {{ weekHeaders[day-1] | date:'dd-MM' }}
                            </div>
                            <div class="text-center">
                                {{ weekHeaders[day-1] | date:'EEEE' }}
                            </div>
                        </th>
                        <td cdk-cell *cdkCellDef="let user"  [class.background--highlighted]="day === today">
                            <div *ngIf="lev >= 4" class="text-center clickable--link" (click)="onReopen(user, day)">
                                {{ (user['doneDag'+day]?.cd | dateUtc:'dd-MM-yyyy') || '' }}
                            </div>
                            <div *ngIf="lev < 4" class="text-center">
                                {{ (user['doneDag'+day]?.cd | dateUtc:'dd-MM-yyyy') || '' }}
                            </div>
                        </td>
                    </ng-container>
                </ng-container>

                <tr class="table__header--border" cdk-header-row *cdkHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: displayColumns"></tr>

            </table>
        </div>

    </div>
</div>
